<template>
    <div class="basic_wrap">
        <van-nav-bar
                safe-area-inset-top
                fixed
                left-arrow
                @click-left="$router.back()"
                :title="$t('lang.新闻资讯')"
        />
        <div class="content" v-html="content"></div>
    </div>
</template>


<script>
import NewsCard from '@/components/NewsCard/index.vue';
import Fetch from '@/utils/fetch';

export default {
    name: "newDetail",
    components: {NewsCard},
    data(){
        return {
            content: '',
        }
    },
    created() {
        this.$parent.footer('newDetail', false)
        Fetch('/index/article_detail', {id: this.$route.query.id}).then(res =>{
            this.content = res.data.content
        })
    }
}
</script>



<style scoped lang="less">
/deep/ .van-nav-bar {
  color: rgb(239, 216, 196);
  background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
  color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
  color: rgb(239, 216, 196);
}

.basic_wrap {
  padding-top: 46px;
  display: flex;
  height: 100vh;
  box-sizing: border-box;
  flex-direction: column;
  background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;

  .content {
    padding: 10px;
    color: rgb(255, 231, 206) !important;
  }
}
</style>
